export default {
  madeInFrance: {
    title: {
      fr: "Polynhome,\nl'innovation française,\nmaîtrisée à chaque étape.",
      en: "Polynhome,\nFrench innovation,\nmastered at every step.",
    },
    description: {
      description1: {
        fr: "Conçues, fabriquées et assemblées en France.\n<strong>Nous possédons la propriété intellectuelle et industrielle de nos solutions.</strong>",
        en: "Designed, manufactured and assembled in France.\n<strong>We fully own the intellectual and industrial property of our solutions.</strong>",
      },
      description2: {
        fr: "Nous avons une maîtrise agile et totale du matériel au logiciel. Grâce à un circuit court, nous garantissons une intégration parfaite et un accompagnement sur-mesure que ce soit sur les IoT, le Edge Computer ou la plateforme d’hypervision.",
        en: "From hardware to software, we control the entire technology stack. This integrated approach ensures seamless deployment and tailored support across IoT devices, the Edge Computer and the building management platform.",
      },
    },
  },
};
